module.exports = __webpack_public_path__ + "static/media/18ECA15.3e53229c.jpg";